<template>
  <div class="admin-page">
    <div class="admin-toolbar">
      <div class="admin-toolbar__actions">
        <el-input
          v-model="filters.keyword"
          placeholder="用户名/昵称/邮箱/UUID"
          clearable
          class="filter-input"
          @keyup.enter="fetchList"
        />
        <el-input-number
          v-model="filters.minDirectInvites"
          :min="0"
          placeholder="最少直接邀请"
          controls-position="right"
          class="filter-num"
        />
        <el-input-number
          v-model="filters.minTotalInvites"
          :min="0"
          placeholder="最少总下级"
          controls-position="right"
          class="filter-num"
        />
        <el-checkbox v-model="filters.onlyWithInvites" @change="fetchList">仅显示有下级</el-checkbox>
        <el-checkbox v-model="filters.buildTree" @change="fetchList">树形展示</el-checkbox>
        <el-button type="primary" @click="fetchList">查询</el-button>
      </div>
    </div>

    <el-table
      :data="nodes"
      v-loading="loading"
      style="width: 100%"
      row-key="userId"
      :tree-props="filters.buildTree ? { children: 'children' } : undefined"
      :default-expand-all="filters.buildTree"
    >
      <el-table-column prop="userId" label="用户ID" width="90" />
      <el-table-column prop="username" label="用户名" width="120" />
      <el-table-column prop="nickname" label="昵称" width="120" />
      <el-table-column prop="inviterUsername" label="邀请人" width="120">
        <template #default="scope">
          <span v-if="scope.row.inviterUserId">{{ scope.row.inviterUsername || scope.row.inviterUserId }}</span>
          <span v-else class="muted">—</span>
        </template>
      </el-table-column>
      <el-table-column prop="directCount" label="第1层" width="72" align="center" />
      <el-table-column prop="layer2Count" label="第2层" width="72" align="center" />
      <el-table-column prop="layer3Count" label="第3层" width="72" align="center" />
      <el-table-column prop="layer4Count" label="第4层" width="72" align="center" />
      <el-table-column prop="layer5Count" label="第5层" width="72" align="center" />
      <el-table-column prop="totalDescendants" label="总下级" width="80" align="center" />
      <el-table-column prop="uuid" label="UUID" min-width="180" show-overflow-tooltip />
    </el-table>

    <AdminPagination
      v-model:current-page="currentPage"
      v-model:page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :total="total"
      @size-change="fetchList"
      @current-change="fetchList"
    />
  </div>
</template>

<script>
import axios from 'axios'
import AdminPagination from '@/components/AdminPagination.vue'

export default {
  name: 'InviteTreeManagement',
  components: { AdminPagination },
  data() {
    return {
      loading: false,
      nodes: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      filters: {
        keyword: '',
        onlyWithInvites: true,
        minDirectInvites: 0,
        minTotalInvites: 0,
        buildTree: false
      }
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      this.loading = true
      try {
        const res = await axios.post('/api/v1/admin/invite/tree/list', {
          page: this.currentPage,
          pageSize: this.pageSize,
          keyword: this.filters.keyword || undefined,
          onlyWithInvites: this.filters.onlyWithInvites,
          minDirectInvites: this.filters.minDirectInvites || 0,
          minTotalInvites: this.filters.minTotalInvites || 0,
          buildTree: this.filters.buildTree
        })
        if (res.data.code !== 200) {
          this.$message.error(res.data.message || '加载失败')
          return
        }
        this.nodes = res.data.data?.nodes || []
        this.total = res.data.data?.total || 0
      } catch (e) {
        this.$message.error(e.response?.data?.message || '加载失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.filter-input { width: 220px; }
.filter-num { width: 150px; }
.muted { color: #909399; }
</style>
